import {appdata} from "../../logic_tmp/appdata/AppData";
import i18next from "i18next";
import {datadogLogs} from "@datadog/browser-logs";
import {getProfile} from "../../logic_tmp/storage/LgProfile";
import {getObjectFromCache} from "../../logic_tmp/storage/DataCache";

export function translateTicketsNumber(count) {
    if (count === 1 || count === 21)
        return "oneTicket"
    if (count === 2 || count === 3 || appdata.count === 4)
        return "234Tickets"
    return "manyTickets"

}

export function resolve(key) {
    // @ts-ignore
    let ret = appdata.product[key]["default"]
    if (appdata.skin !== "" && appdata.skin !== undefined)
        // @ts-ignore
        ret = appdata.product[key][appdata.skin];
    ret = ret[i18next.language];
    if (appdata.product["concertCode"] !== undefined)
        ret = appdata.product["concertCode"] + "/" + ret;
    else
        ret = appdata.productCode + "/" + ret;
    return ret;

}

export function hash(s) {
    let ret = 0;
    let a = 0;
    for (a = 0; a < s.length; a++) {
        let ch = s.charCodeAt(a);
        ret = ret + ch;

    }
    return ret;
}


export function calcHeader(t) {
    if (appdata.leadAction === "Invitation") {
        if (appdata.count === 1)
            appdata.header = appdata.count + " " + t("invitation-gen");
        else
            appdata.header = appdata.count + " " + t("invitations-gen");
    } else
        appdata.header = appdata.count + " " + t(translateTicketsNumber(appdata.count))
    if (appdata.amount > 0)
        appdata.header = appdata.header + " " + appdata.amount + appdata.product["currency"]
    if (appdata.priceNote !== undefined)
        appdata.header = appdata.header + " " + appdata.priceNote;
    if (appdata.product.type === "DONATION")
        appdata.header = t("Donate") + " " + appdata.amount + appdata.product["currency"]
    if (appdata.product.type === "SUBSCRIPTION")
        appdata.header = t("Subscription");
    if (appdata.leadSubAction === "SpecialProposal")
        appdata.header = "..."
    if (appdata.product.type === "LEADGEN")
        appdata.header = t("ThankYou")
    if (appdata.product.type === "PDF")
        appdata.header = t("PDF") + " " + appdata.amount + appdata.product["currency"]
    if (appdata.product.type === "SERVICE") {
        // Для проекта SOPHIA используем ключ "Questions" вместо "VideoProcessing"
        const serviceKey = appdata.product.projectCode === "SOPHIA" ? "Questions" : "VideoProcessing";
        appdata.header = t(serviceKey) + " " + appdata.amount + appdata.product["currency"];
    }


}


//TODO Remove
export function calcUtmParams1() {
    appdata.utm_params =
        "&utm_source=" + appdata.utm_source +
        "&utm_medium=" + appdata.utm_medium +
        "&utm_campaign=" + appdata.utm_campaign +
        "&utm_content=" + appdata.utm_content +
        "&utm_brand=" + appdata.utm_brand +
        "&referenceId=" + appdata.referenceId +
        "&message=" + appdata.message +
        "&skin=" + appdata.skin;
}


export function logError(error) {
    console.log("---------------ERROR----------------")
    console.log(error);
    console.log(error.message);
    console.log(error.stack);
    console.log("------------------------------------")
    logToDD("error", error, {"stack": error.stack})
}

export function calculateGeo() {
    let cachedObj = getObjectFromCache("ONEDAY", "Geo")
    let geo = ""
    if (cachedObj !== undefined && cachedObj["geo"] !== undefined)
    {
        let r = cachedObj["geo"]
        geo =
            r["country"] + ":" +
            r["region"] + ":" +
            r["city"] + ":" +
            r["address"] + ":" +
            r["y"] + ":" + r +
            r["x"] + ":" + r
    }
    return geo
}

export function logPageOpened(page, pageType) {
    let geo = calculateGeo()
    logCounter("PageOpened:" + page + " "  + geo,
        {
            aLocationType: pageType,
            aLocation: page,
            bActionType: "IN",
            bAction: "Open",
            cDestinationType: appdata.prevViewType,
            cDestination: appdata.prevViewId,
            zType: "PageTraffic",
            value: 1
        }
    )
}

export function logCounter(message, payload) {

    let counterPayload = {counter: payload}
    logToDD("debug", message, counterPayload)
}

export function logDebug(message, payload) {
    logToDD("debug", message, payload)
}


export function logInfo(message, payload) {
    logToDD("info", message, payload)
}
export function logPixel(pixel) {
    logInfo("Pixel:.." + pixel, {pixel:pixel})
}
export function logWarn(message, payload) {
    logToDD("warn", message, payload)
}

export function logErrorImpl(message, payload) {
    logToDD("error", message, payload)
}

function logToDD(severity, message, payload) {
    try {
        let nowDate = new Date();
        let dateS = nowDate.getFullYear()+'/'+(nowDate.getMonth()+1)+'/'+nowDate.getDate()
        let messageContext = {
            profileId: getProfile().profileId,
            customerId: getProfile().customerId,
            skin: appdata.skin,
            productCode: appdata.productCode,
            cmpCode: appdata.cmpCode,
            geoCode: appdata.geoCode,
            setLang: appdata.setLang,
            setType: appdata.setType,
            setFocusCode: appdata.setFocusCode,
            currentEntryPath: appdata.currentPath,
            firstEntryPath: getProfile().firstEntryPath,
            action: appdata.action,
            iframeId: appdata.iframeId,
            parentPath: appdata.parentPath,
            lmKey: appdata.lmKey,
            viewId: appdata.viewId,
            dayStr: dateS,
            testColor: appdata.testColor,
            testId: appdata.testId,
            abTest1: appdata.abTest1,
            abTest2: appdata.abTest2,
            abTest3: appdata.abTest3
        }
        if (payload !== undefined)
            Object.keys(payload).forEach((key) => {
                messageContext[key] = payload[key]
            })
        if ("info" === severity)
            datadogLogs.logger.info(message, messageContext)
        else if ("warn" === severity)
            datadogLogs.logger.warn(message, messageContext)
        else if ("error" === severity)
            datadogLogs.logger.error(message, messageContext)
        else if ("debug" === severity)
            datadogLogs.logger.debug(message, messageContext)
        else throw Error("Unknown severity:" + severity)
    } catch (error) {
        datadogLogs.logger.error("Logger error: " + error.message, error.stack)
    }
}
